<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      南头古城站<br>
站点介绍<br>
南投古城位于南山大道与深南大道交汇处，沿南山大道南北方向铺设。周边主要分布了古城社区公园、南头古城、南山博物馆、南头商业步行街、百安居、南山文体中心、泰源装饰建材广场等多个项目，是南头片区文 化、娱乐、居住、商业、城市综合体集中区域。新线开通后预计开放A和D出入口，A出入口直达百安居，D出入口可以到达新海大厦、南山劳动大厦、南山文体中心、南山博物馆、南山图书馆、深圳市南山区荔香学校。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:23	23:19	12号线	4分钟	8分钟<br>
海上田园东	06:29	23:53	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:27	23:19	12号线	8分钟	8分钟<br>
海上田园东	06:30	23:53	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
南山大道东侧、阳光荔景、明舍御园、荔香源、前海华庭、御林华府、悠然天地、百安居<br><br>
D出入口:<br>
南山大道西侧、南山劳动大厦、南山文体中心、深圳市南山区荔香学校、南山图书馆、南山区水产综合楼、红花园社区、宏毕宛小区、英达钰龙园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 南头古城<br>
21、42、81、320、369、M200、M364、M372、M435、M527<br><br>
A出入口:<br>
公交站名： D出入口<br>
南头古城<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>